module.exports = __webpack_public_path__ + "static/media/Weekend-Papers-plus-Everyday-Digita_Mobile.56b4882e.png";